import { styled } from '@mui/material';
import { GridToolbarContainer } from '@mui/x-data-grid-pro';
import { CSSProperties } from 'react';
import { flexBase } from '../../../../Constants';

/**
 * Styled version of the DataGrid's Toolbar Container component.
 */
export default styled(GridToolbarContainer)(() => ({
    ...(flexBase as unknown as CSSProperties),
    flexWrap: 'nowrap',
    padding: 0,
    height: 50,
}));
